import { BANNER_MAPPING } from "./seller-constant";
import { staticFastlyAppUrl } from "./url-constants";

export const PDI_BANNER = {
    [BANNER_MAPPING.MWEB]: `${staticFastlyAppUrl()}/cars24/seo/static/53_20240124_1706116922.jpg`,
    [BANNER_MAPPING.WEB]: `${staticFastlyAppUrl()}/cars24/seo/static/53_20240124_1706117026.jpg`
};

export const PDI_SAMPLE_PDF_URL = `${staticFastlyAppUrl()}/cars24/docs/53_20240513_1715611076.pdf`;

export const APPOINTMENT_STATUS = {
    BOOKED: "BOOKED",
    CONFIRMED: "CONFIRMED",
    CANCELLED: "CANCELLED",
    INSPECTION_STARTED: "INSPECTION_STARTED",
    INSPECTED: "INSPECTED",
    PURCHASED: "PURCHASED",
    MISSED: "MISSED"
};

export const PDI_CAR_TYPE = {
    USED_CAR: "PDI_Used_Car_V2",
    NEW_CAR: "PDI_New_Car_V2"
};

export const PDI_PACKAGE_TYPES = {
    ADVANCED: "ADVANCED",
    STANDARD: "STANDARD"
};

export const PDI_APPOINTMENT_STATUS = {
    APPOINTMENT_CONFIRMED: "appointment_confirmed",
    APPOINTMENT_CONFIRMED_CJ_ASSIGNED: "appointment_confirmed_cj_assigned",
    BOTH_REPORT_IN_PROGRESS: "both_report_in_progress",
    PDI_REPORT_IN_PROGRESS: "pdi_report_in_progress",
    OLD_PDI_REPORT_IN_PROGRESS: "old_pdi_report_in_progress",
    BOTH_FULLFILLED: "both_fullfilled",
    STANDARD_ORDER_FULFILLED: "standard_order_fulfilled",
    NEW_PDI_ORDER_FULFILLED: "new_pdi_order_fulfilled",
    OLD_PDI_ORDER_FULFILLED: "old_pdi_order_fulfilled", // Backwards compatibility
    PARTIAL_FULFILLED: "partially_fullfilled",
    APPOINTMENT_MISSED: "appointment_missed",
    REPORT_FAIL_REFUND_INITIATED: "report_fail_refund_initiated",
    REPORT_FAIL_REFUND_COMPLETED: "report_fail_refund_completed",
    INSPECTION_CANCELLED_REFUND_INITIATED:
    "inspection_cancelled_refund_initiated",
    INSPECTION_CANCELLED_REFUND_COMPLETED:
    "inspection_cancelled_refund_completed",
    SH_FAIL_REFUND_INITIATED: "sh_fail_refund_initiated",
    SH_FAIL_REFUND_COMPLETED: "sh_fail_refund_completed"
};

export const PDI_CATEGORY = {
    NEW_CAR_PDI: "new_car_pre_delivery_inspection",
    PDI_PACKAGE: "pre_delivery_inspection_package",
    USED_CAR_PDI: "pre_delivery_inspection",
    INSPECTION_REPORT: "inspection_report",
    SERVICE_HISTORY: "service_history"
};

export const APPOINTMENT_CARD_BADGE_CONFIG = {
    [PDI_PACKAGE_TYPES.ADVANCED]: {
        label: "ADVANCED",
        rounded: "right",
        type: "dark",
        variant: "gray"
    },
    [PDI_PACKAGE_TYPES.STANDARD]: {
        label: "STANDARD",
        rounded: "right",
        type: "dark",
        variant: "accent"
    }
};

export const REDIRECTED_UTM_SOURCE = "odo-tamper";
